import SubFeaturesBlock from './sub-features-block-view';

export default SubFeaturesBlock;
